<template>
    <b-card-group
            class="details-container d-block"
    >
        <b-row>
            <b-col>
                <b-card-group
                        class="price-details"
                >
                    <b-card-text
                            v-if="price"
                            class="price m-0"
                    >
                        {{ formatNumber(price) }}
                    </b-card-text>
                    <b-card-text
                            v-if="!price"
                            class="price m-0"
                    >
                        ---
                    </b-card-text>
                    <property-listing-card-price-arrows :hide-on-balloon="true" />
                </b-card-group>
            </b-col>
        </b-row>

        <b-row>
            <b-col>
                <div
                        class="card-text address"
                >
                    <b-row
                            v-if="displayAddress"
                    >
                        <b-col class="address">
                            {{ displayAddress }}
                        </b-col>
                    </b-row>
                    <b-row
                            v-else
                    >
                        <b-col class="address">
                            Address Not Disclosed
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col>
                            {{ printStateCity }}
                        </b-col>
                    </b-row>
                </div>
            </b-col>
        </b-row>
    </b-card-group>
</template>

<script>
    import PropertyListingCardPriceArrows from './PropertyListingCardPriceArrows';
    import {formatNumber} from '../../../helpers/functions';
    import PropertyAppResource from "@milestoneslabs/milestones-core-js/src/AppResources/PropertyAppResource";
    import {toLower} from "lodash";

    export default {
        name: 'PropertyListingCardDetails',
        components: {PropertyListingCardPriceArrows},
        props: {
            propertyAppResource: {
                type: Object,
                required: true,
                validator(value) {
                    return value.constructor.name === (new PropertyAppResource()).constructor.name;
                }
            },
        },
        computed: {
            formattedAddress() {
                let formattedAddress = toLower(this.address.street).replace(/\b\w/g, l => l.toUpperCase());
                if (this.address.preDirection) {
                    formattedAddress = this.address.preDirection + ' ' + formattedAddress;
                }
                if (this.address.suffix) {
                    formattedAddress = formattedAddress + ' ' + this.address.suffix;
                }
                if (this.address.postDirection) {
                    formattedAddress = formattedAddress + ' ' + this.address.postDirection;
                }
                if (this.address.streetNumber) {
                    formattedAddress = this.address.streetNumber + ' ' + formattedAddress;
                }
                return formattedAddress;
            },
            printStateCity() {
                let propStateCity = (this.address || {}).city || '';
                if (this.address.state) {
                    propStateCity += (propStateCity ? ', ' : '') + this.address.state;
                } else if (this.address.county) {
                    propStateCity += (propStateCity ? ', ' : '') + this.address.county;
                }
                return propStateCity;
            },
            address() {
                let propDetails = this.propertyAppResource.details || {};
                return propDetails.address || propDetails;
            },
            price() {
                let price = this.propertyAppResource.price;
                if (this.propertyAppResource.isSold) {
                    price = this.propertyAppResource.details.salePrice;
                }
                return price;
            },
            displayAddress() {
                if (this.address?.deliveryLine) {
                    return this.address.deliveryLine;
                }
                return this.formattedAddress;
            },
        },
        methods: {
            formatNumber,
        },
    };
</script>
